import React from "react";
import { ShieldCheck, BadgeCheck, LifeBuoy, Plane } from "lucide-react";

/**
 * TrustBar — 4-column strip of buyer-confidence signals.
 * Sits just below the hero to kill purchase anxiety (Jumia-style).
 *
 * Mobile: 2x2 grid. Desktop: single row.
 */
const ITEMS = [
  {
    icon: ShieldCheck,
    title: "Buyer Protection",
    body: "Pay safely via Stripe or PayPal. Money is held until you confirm delivery.",
    color: "text-[#2A3D36]",
    bg: "bg-[#2A3D36]/8",
  },
  {
    icon: BadgeCheck,
    title: "Verified Sellers",
    body: "Sellers verify ID and address. Look for the ✓ badge on every listing.",
    color: "text-[#C05A3C]",
    bg: "bg-[#C05A3C]/10",
  },
  {
    icon: LifeBuoy,
    title: "Free Resolution",
    body: "Got an issue? Our dispute team mediates refunds — free, always.",
    color: "text-[#D9923B]",
    bg: "bg-[#D9923B]/12",
  },
  {
    icon: Plane,
    title: "Africa → Diaspora",
    body: "Most products ship worldwide. Local services within your city.",
    color: "text-[#1A2024]",
    bg: "bg-[#1A2024]/8",
  },
];

const TrustBar = () => {
  return (
    <section
      data-testid="trust-bar"
      className="bg-white border-y border-black/10"
    >
      <div className="container-narrow grid grid-cols-2 lg:grid-cols-4 gap-0 divide-y divide-x-0 lg:divide-y-0 lg:divide-x divide-black/10">
        {ITEMS.map(({ icon: Icon, title, body, color, bg }) => (
          <div
            key={title}
            data-testid={`trust-item-${title.toLowerCase().replace(/\s+/g, "-")}`}
            className="flex items-start gap-3 px-5 py-5 sm:px-6 sm:py-6"
          >
            <div className={`shrink-0 w-10 h-10 sm:w-11 sm:h-11 rounded-full grid place-items-center ${bg}`}>
              <Icon className={`w-5 h-5 ${color}`} />
            </div>
            <div className="min-w-0">
              <div className="font-semibold text-sm sm:text-base text-[#1A1A1A] leading-tight">
                {title}
              </div>
              <div className="text-xs text-muted-foreground mt-1 leading-relaxed">
                {body}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TrustBar;
